import { types } from '../constants'

const index = {
  pending: `${types.listPayments}_PENDING`,
  fulfilled: `${types.listPayments}_FULFILLED`,
  rejected: `${types.listPayments}_REJECTED`,
  setPage: types.listPaymentsSetPage,
  setPerPage: types.listPaymentsSetPerPage
}

export const listPayments = {
  [index.pending]: ({ draft }) => {
    draft.industry.wallet.listPayments.loading = true
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.industry.wallet.listPayments.data = action.payload.data

    draft.industry.wallet.listPayments.pages = action.payload.pages
    draft.industry.wallet.listPayments.total = action.payload.total
    draft.industry.wallet.listPayments.page = action.payload.page

    draft.industry.wallet.listPayments.loading = false
    draft.industry.wallet.listPayments.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.industry.wallet.listPayments.loading = false
    draft.industry.wallet.listPayments.error = action.payload
    draft.industry.wallet.listPayments.total = 0
    draft.industry.wallet.listPayments.data = null
  },
  [index.setPage]: ({ draft, action }) => {
    draft.industry.wallet.listPayments.page = action.payload
  },
  [index.setPerPage]: ({ draft, action }) => {
    draft.industry.wallet.listPayments.perPage = action.payload
  }
}
